import React, { useRef, useEffect } from "react"
import { Prompt } from "react-router-dom"

export function PreventPageNavigation({
  message,
  when = true,
}: {
  message: string
  when?: boolean
}) {
  const whenRef = useRef(when)
  whenRef.current = when
  useEffect(() => {
    const handler = (event: { returnValue?: string }) => {
      if (whenRef.current) {
        event.returnValue = "There is pending work. Sure you want to leave?"
      }
    }
    window.addEventListener("beforeunload", handler)
    return () => {
      window.removeEventListener("beforeunload", handler)
    }
  }, [])

  return <Prompt when={when} message={message} />
}
